module.exports = __webpack_public_path__ + "img/developer-1.91fc5413.svg";